import React from 'react';
import { Navigate } from 'react-router-dom';

function PrivateRoute({ children }) {
    const token = localStorage.getItem('authToken'); // Check if token exists
    return token ? children : <Navigate to="/admin-login" replace />;
}

export default PrivateRoute;